<template>
    <div class="profile-container container-fixed">
        <div class="row no-gutters justify-content-center">
            <div class="col-md-4 mt-4 mb-4 text-center">
                <button v-if="!pendingTransaction" @click="newBlockHead" class="btn btn-primary">
                    {{ 'NEW_BLOCKHEAD' | translate }}
                </button>
                <button v-else class="btn btn-secondary">
                    {{ 'PLEASE_WAIT' | translate }}
                </button>
            </div>
        </div> 
        <div v-if="userBlockHeads.length > 0" class="row no-gutters justify-content-center">
            <div v-for="(blockHead, index) in userBlockHeads" :key="index" class="col-md-2 text-center">
               <BlockHead :blockhead="blockHead" />
            </div>
        </div> 
        <div v-else class="col-md-12 mb-2 text-center">
            <div class="generic-container">
                {{ 'NO_BLOCKHEADS' | translate }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import BlockHead from "../components/BlockHead";

export default {
    name: 'About',
    components: { BlockHead },
    computed: {
        ...mapGetters({
            address: 'getAddress',
            userBlockHeads: 'getUserBlockHeads',
            pendingTransaction: 'getPendingTransaction'
        })    
    },
    created () {},
    methods: {
        newBlockHead () {

            this.$store.commit('updatePendingTransaction', { status: true });
            this.$store.dispatch('newBlockHead').then((response) => {

                if (response.message == 'success') {

                    this.$notify({
                        group: "app",
                        title: "Success!",
                        text: 'You have created a new BlockHead!'
                    });

                } else if (response.message == 'error') {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was an error with your transaction'
                    });

                } else {

                    this.$notify({
                        group: "app",
                        title: "Warning!",
                        text: 'There was a problem loading your data, please refresh'
                    });

                }

                this.$store.commit('updatePendingTransaction', { status: false });

            });
        }
    }
}
</script>

<style scoped lang="less">
.profile-container {
    color: #fff;

    .blockhead-item {
        margin: 5px;
    }

    .generic-container {
        padding: 40px;
        margin: 0 5px;
        background: #3C3F44;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Profile.vue